import React from "react";
import { IconProps } from "../../utils/global-types/global-types";

const NetworkIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-6 h-6"}
      {...rest}
    >
      <g clipPath="url(#clip0_1954_31692)">
        <g fill="currentColor" clipPath="url(#clip1_1954_31692)">
          <path d="M5.375 16.425c-.025 0-.058.017-.083.017A8.34 8.34 0 0 1 1.55 12.7c0-.025.017-.058.017-.083 1.016.3 2.066.525 3.108.7.183 1.05.4 2.091.7 3.108M16.45 12.708c-.825 1.659-2.2 3-3.875 3.809.317-1.059.583-2.125.758-3.2 1.05-.175 2.084-.4 3.1-.7-.008.033.017.066.017.091M16.517 5.425a26 26 0 0 0-3.184-.758 23 23 0 0 0-.758-3.184 8.38 8.38 0 0 1 3.942 3.942M5.375 1.575a26 26 0 0 0-.692 3.1 24 24 0 0 0-3.2.75A8.4 8.4 0 0 1 5.292 1.55c.025 0 .058.025.083.025M11.909 4.492a26 26 0 0 0-5.817 0c.208-1.142.475-2.284.85-3.384.016-.066.008-.116.016-.183A8.7 8.7 0 0 1 9 .667c.7 0 1.383.1 2.034.258.008.067.008.117.024.183.376 1.109.642 2.242.85 3.384M4.492 11.908c-1.15-.208-2.284-.475-3.384-.85-.066-.016-.116-.008-.183-.016A8.7 8.7 0 0 1 .667 9c0-.7.1-1.383.258-2.033.067-.009.117-.009.183-.025a25 25 0 0 1 3.384-.85 27 27 0 0 0 0 5.816M17.333 9c0 .708-.1 1.383-.258 2.042-.067.008-.117 0-.183.016a25 25 0 0 1-3.384.85 26 26 0 0 0 0-5.816c1.142.208 2.284.475 3.384.85a.7.7 0 0 0 .183.025c.158.658.258 1.333.258 2.033M11.909 13.508c-.209 1.15-.476 2.284-.85 3.384-.017.066-.017.116-.025.183A8.6 8.6 0 0 1 9 17.333c-.708 0-1.383-.1-2.042-.258-.008-.067 0-.117-.016-.183a25 25 0 0 1-.85-3.384A26 26 0 0 0 9 13.692c.975 0 1.95-.075 2.909-.184M12.136 12.136a25 25 0 0 1-6.272 0 25 25 0 0 1 0-6.272 25 25 0 0 1 6.272 0 25 25 0 0 1 0 6.272"></path>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1954_31692">
          <path fill="#fff" d="M0 0h18v18H0z"></path>
        </clipPath>
        <clipPath id="clip1_1954_31692">
          <path fill="#fff" d="M-1-1h20v20H-1z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default NetworkIcon;
